/**
 * @desc iam单点登陆回调
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.iamCallback.login.Params, options?: any) {
  return updateResponse(
    http(URL + `/iam/login`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
